<template>
  <div class="jukebox-card">
    <div v-if="loading" class="loading-message">
      <div class="loading-text">Jukebox wordt opgewarmd...</div>
      <div class="loading-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
    <div v-else class="song-columns">
      <div v-for="column in songColumns" :key="column.id" class="song-list">
        <div v-for="song in column.songs" :key="`${song.code1}-${song.code2}`" class="song-row">
          <span class="star star--left">★</span>
          <div class="song-info">
            <div v-if="song.artist" class="artist">{{ song.artist }}</div>
            <div class="song-title">{{ song.title }}</div>
          </div>
          <span class="star star--right">★</span>
          <div class="selection-code">{{ (song.index).toString().padStart(2, '0') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JukeboxWidget',
  props: {
    songs: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    songColumns() {
      const columnsCount = 3
      const columns = Array(columnsCount)
        .fill(null)
        .map((_, index) => ({
          id: index,
          songs: [],
        }))

      const songsPerColumn = Math.ceil(this.songs.length / columnsCount)

      this.songs.forEach((song, index) => {
        const columnIndex = Math.floor(index / songsPerColumn)
        if (columnIndex < columnsCount) {
          columns[columnIndex].songs.push({
            ...song,
            index: index + 1,
          })
        }
      })

      return columns
    },
  },
}
</script>

<style scoped>
@import '@dpgradio/creative/styles/fonts/joe';

* {
  box-sizing: border-box;
}

.jukebox-card {
  background-color: #f7e8d0;
  border: 3px solid #8b4513;
  border-radius: 8px;
  padding: 25px;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

@media (min-width: 1024px) {
  .jukebox-card {
    width: 90vw;
    margin-left: calc(-45vw + 50%);
    max-width: 90vw;
  }
}

.song-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 15px;
}

.song-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.song-row {
  display: flex;
  align-items: center;
  background-color: #faf5ed;
  border: 2px solid #d2691e;
  height: 70px;
  gap: 10px;
  border-radius: 4px;
  overflow: hidden;
}

.song-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  gap: 2px;
  padding: 0 5px;
}

.artist {
  font-family: 'Geomanist', 'Arial', sans-serif;
  font-size: 14px;
  color: #333;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  width: 100%;
}

.song-title {
  font-family: 'Geomanist', 'Arial', sans-serif;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
  color: #8b0000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  width: 100%;
}

.listener {
  font-family: 'Geomanist', 'Arial', sans-serif;
  font-size: 14px;
  color: #666;
  font-style: italic;
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  width: 100%;
}

.selection-code {
  font-family: 'Geomanist', 'Arial', sans-serif;
  background-color: #333;
  color: #fff;
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  border-left: 2px solid #d2691e;
}

.star {
  color: #d2691e;
  font-size: 16px;
  flex-shrink: 0;
}

.star--left {
  padding-left: 10px;
}

@media (max-width: 768px) {
  .song-columns {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}

.loading-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 20px;
}

.loading-text {
  font-family: 'Geomanist', 'Arial', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #8b4513;
  text-align: center;
}

.loading-dots {
  display: flex;
  gap: 8px;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: #d2691e;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.3s;
}

.dot:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

@media (max-width: 600px) {
  .jukebox-card {
    padding: 10px;
  }

  .song-row {
    height: 60px;
  }

  .artist {
    font-size: 14px;
  }

  .song-title {
    font-size: 16px;
  }

  .listener {
    font-size: 12px;
  }

  .selection-code {
    width: 50px;
    font-size: 16px;
  }

  .loading-text {
    font-size: 20px;
  }
}
</style>
